import { render, staticRenderFns } from "./BankSelectionFlow.vue?vue&type=template&id=3496a1b7&scoped=true&"
import script from "./BankSelectionFlow.vue?vue&type=script&lang=js&"
export * from "./BankSelectionFlow.vue?vue&type=script&lang=js&"
import style0 from "./BankSelectionFlow.vue?vue&type=style&index=0&id=3496a1b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3496a1b7",
  null
  
)

export default component.exports